/**
 * @see {@link https://wiki.move-elevator.de/display/DVKMU/Statusliste+bNet+--%3E+ME#StatuslistebNet%3EME-Ankaufabgelehnt-PurchaseDecision}
 */
const BnetPurchaseAlertBlackList = [3, 7, 11, 14, 16, 17, 20];

export default BnetPurchaseAlertBlackList;
